import { render, staticRenderFns } from "./CommonBarMenu.vue?vue&type=template&id=1084a096"
import script from "./CommonBarMenu.vue?vue&type=script&lang=js"
export * from "./CommonBarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports